/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
import { connect } from 'react-redux';
import { change } from 'redux-form';
import { modelTypesByForm } from '#src/js/constants/models/modelTypes/index.js';
import { createStructuralResponseAndGetUploadUrl } from '#actions/models/structuralResponses.js';
import { fetchModel } from '#actions/models/model.js';
import { uploadToUrl } from '#actions/models/uploads.js';
import { selectStructuralResponseIsProcessing } from '#selectors/entities/models.js';
import StructuralResponseUploader from './StructuralResponseUploader.jsx';

const mapStateToProps = (state, ownProps) => {
  const { form, modelId, name } = ownProps;
  const { selectFormValues } = modelTypesByForm[form];
  const value = selectFormValues(state, name);
  return {
    value,
    isUploading: selectStructuralResponseIsProcessing(state, { modelId, responseId: value }),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { edpKey, form, method, modelId, name, responseItemKey } = ownProps;
  return {
    handleUpload: file => {
      dispatch(change(form, name, null));
      dispatch(
        createStructuralResponseAndGetUploadUrl(modelId, {
          edp: { key: edpKey },
          method,
          itemKey: responseItemKey,
        })
      ).then(data => {
        const { url, uuid } = data.payload;
        dispatch(fetchModel(modelId)).then(() => {
          dispatch(change(form, name, uuid));
        });
        dispatch(uploadToUrl(file, url));
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StructuralResponseUploader);
